/** 좌표 매핑(청구·3종) 필드 JSON의 fontKey — 서버 PdfKoreanFontResolver와 동일 식별자 */
export const PDF_MAPPING_FONT_OPTIONS = [
  { value: '', label: '자동 (환경 기본)' },
  { value: 'MALGUN', label: '맑은 고딕' },
  { value: 'MALGUN_SEMILIGHT', label: '맑은 고딕 세미라이트' },
  { value: 'NANUM_GOTHIC', label: '나눔고딕' },
  { value: 'NANUM_BARUN_GOTHIC', label: '나눔바른고딕' },
  { value: 'NOTO_SANS_CJK', label: 'Noto Sans CJK (서버에 폰트 설치 시)' },
  { value: 'BAEKMUK_GULIM', label: '백묵 굴림 (Linux: baekmuk-ttf)' },
  { value: 'BAEKMUK_BATANG', label: '백묵 바탕 (Linux: baekmuk-ttf)' },
  { value: 'BAEKMUK_DOTUM', label: '백묵 돋움 (Linux: baekmuk-ttf)' },
  { value: 'APPLE_GOTHIC', label: 'Apple Gothic (macOS)' },
]

/** 미리보기 오버레이용 대략적인 글꼴 — 실제 PDF와 픽셀 단위로 완전히 같지 않을 수 있음 */
export function previewFontFamilyForMappingKey(fontKey) {
  const k = String(fontKey || '').trim().toUpperCase().replace(/-/g, '_')
  switch (k) {
    case 'MALGUN':
    case 'MALGUN_GOTHIC':
      return '"Malgun Gothic", "Apple SD Gothic Neo", sans-serif'
    case 'MALGUN_SEMILIGHT':
    case 'MALGUN_SL':
      return '"Malgun Gothic Semilight", "Malgun Gothic", sans-serif'
    case 'NANUM_GOTHIC':
    case 'NANUM':
      return '"Nanum Gothic", "NanumGothic", sans-serif'
    case 'NANUM_BARUN_GOTHIC':
    case 'NANUM_BARUN':
    case 'BARUN':
      return '"NanumBarun Gothic", "Nanum Gothic", sans-serif'
    case 'NOTO_SANS_CJK':
    case 'NOTO_CJK':
    case 'NOTO':
      return '"Noto Sans CJK KR", "Noto Sans KR", sans-serif'
    case 'APPLE_GOTHIC':
    case 'APPLEGOTHIC':
      return '"Apple Gothic", sans-serif'
    case 'BAEKMUK_GULIM':
    case 'BAEKMUK_GULIM_TTF':
      return '"Gulim", "Baekmuk Gulim", "Apple SD Gothic Neo", serif'
    case 'BAEKMUK_BATANG':
    case 'BAEKMUK_BATANG_TTF':
      return '"Batang", "Baekmuk Batang", "Apple SD Gothic Neo", serif'
    case 'BAEKMUK_DOTUM':
    case 'BAEKMUK_DOTUM_TTF':
      return '"Dotum", "Baekmuk Dotum", "Apple SD Gothic Neo", sans-serif'
    case 'BAEKMUK_HLINE':
    case 'BAEKMUK_HEADLINE':
      return '"Headline", "Baekmuk Headline", sans-serif'
    default:
      return '"Malgun Gothic", "Nanum Gothic", "Apple SD Gothic Neo", sans-serif'
  }
}
